import { Grid } from "@material-ui/core"
import { InputTextArea, MasterButton, Modal } from "App/Component/ui"
import { DISABLED_BUTTON_SUBMIT, instance2 } from "App/constants"
import {
  defaultToastError,
  defaultToastSuccess,
  getLocalName,
} from "App/utils/helpers"
import React, { useState } from "react"
import {
  RESET_STATE_VERIFIKASI_BOOKING,
  STATUS_CANCEL_SIMRS,
  urlCancelBooking,
} from "./helpers"

const SHOW_BUTTON_CANCEL = {
  label: "CANCEL BOOKING",
  color: "danger",
  state: false,
}

function ModalCancelBooking({
  setShowModal,
  setNewData,
  setFormData,
  formData,
  setShowModalCancel,
}) {
  const [alasan, setAlasan] = useState("")
  const [disabled, setDisabled] = useState(SHOW_BUTTON_CANCEL)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      await instance2
        .post(urlCancelBooking, {
          verif_remark: alasan,
          verif_from: STATUS_CANCEL_SIMRS,
          verif_user: getLocalName(),
          idbooking: formData.id_booking_form,
        })
        .then(() => {
          defaultToastSuccess("Berhasil cancel booking")
          setNewData()
        })
        .then(() => {
          setDisabled(SHOW_BUTTON_CANCEL)
          setFormData(RESET_STATE_VERIFIKASI_BOOKING)
          setShowModalCancel(false)
        })
    } catch (error) {
      setDisabled(SHOW_BUTTON_CANCEL)
      defaultToastError(error?.response?.data?.message)
      setShowModalCancel(false)
    }
  }

  return (
    <Modal title={"Cancel Booking"} show={setShowModal}>
      <Grid item sm={12}>
        <InputTextArea
          label={"ALASAN"}
          placeholder={"Alasan"}
          name="alasan"
          value={alasan}
          onChange={(e) => {
            setAlasan(e.target.value)
          }}
          id="alasan"
          rows={"3"}
        />
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        style={{
          gap: "1rem",
          marginTop: "0.5rem",
        }}
        alignItems="center"
      >
        <MasterButton
          type={"button"}
          color={disabled.color}
          name={disabled.label}
          disabled={disabled.state}
          onClick={(e) => handleSubmit(e)}
          size="md"
        />
      </Grid>
    </Modal>
  )
}

export default ModalCancelBooking
